import { useTheme } from '@mui/material';

export const ErrorNoItems = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
        background: { primary: primaryBackground },
    } = theme.colors.other.icon;

    return (
        <svg
            width="263"
            height="211"
            viewBox="0 0 263 211"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M157.176 181.116C138.323 184.432 80.0505 190.567 53.7129 186.702C51.2411 186.339 49.9257 183.721 50.92 181.429C61.9461 156.012 80.9678 108.495 81.7566 83.8499C97.1838 85.2943 138.783 81.0873 154.271 80.6299C171.077 80.1339 174.988 76.3635 173.999 95.3498C173.62 102.634 160.48 182.984 157.176 181.116Z"
                fill={primaryBackground}
            />
            <path
                d="M40.6281 47.4718C34.1996 48.5877 15.567 50.5643 4.78695 49.847C2.28129 49.6803 0.949306 47.0938 1.9363 44.7847C6.12223 34.9916 12.0336 19.7172 12.3025 11.4267C18.0966 11.962 33.7201 10.4029 39.5369 10.2334C45.8489 10.0496 47.3179 8.65238 46.9466 15.6884C46.8041 18.3877 41.8689 48.164 40.6281 47.4718Z"
                fill={primaryBackground}
            />
            <path
                d="M191 50.2188C191 39.2682 192.726 14.7032 193.59 3.78961C194.01 11.5915 190.533 57.6326 196.096 60.6977C199.354 62.4933 225.624 60.8972 237.595 59.7666C249.566 58.636 249.083 55.3772 251.362 48.5937C253.641 41.8101 256.682 18.0011 257.214 9.8209C257.746 1.64072 255.927 3.78961 249.083 2.49476C243.608 1.45888 211.039 5.26941 195.44 7.30416C209.313 5.1461 238.761 0.71899 245.568 0.275046C254.077 -0.279885 260.181 -0.649839 259.442 6.00933C258.702 12.6685 256.852 32.461 254.077 46.3343C251.303 60.2075 246.678 61.6874 239.834 62.0573C232.99 62.4273 203.024 64.462 198.214 64.0921C193.405 63.7221 191 63.9071 191 50.2188Z"
                fill={primaryStroke}
            />
            <path
                d="M9.99976 125.798C9.9995 99.6752 14.1077 41.075 16.1618 15.0402C17.1618 33.6518 5.2638 146.727 18.4998 154.039C26.254 158.323 92.515 155.197 121 152.5C149.485 149.803 151.077 140.182 156.5 124C161.923 107.818 168.234 49.514 169.5 30C170.766 10.486 172.355 10 154.5 8.5C141.286 7.38991 57.6829 18.5703 20.5637 23.4243C53.5749 18.2761 123.647 7.71517 139.844 6.65613C160.091 5.33233 174.616 4.44979 172.855 20.3354C171.095 36.221 166.693 83.4366 160.091 116.532C153.489 149.627 142.485 153.157 126.199 154.039C109.914 154.922 38.6098 159.776 27.1659 158.893C15.722 158.011 10.0001 158.452 9.99976 125.798Z"
                fill={primaryStroke}
            />
            <path
                d="M112.151 99.8647C106.315 94.3922 99.3318 89.8053 92.6699 85.3753C98.9346 76.5859 101.929 71.8655 110.491 60.2312C102.97 67.9711 96.7236 75.7578 90.5885 83.8557C80.8479 77.7325 70.3198 71.2887 59.8671 66.4809C68.5379 73.8792 79.3954 80.1845 89.138 86.1005C85.3838 91.3341 80.35 97.1786 77.2683 102.834C74.8336 106.671 82.6372 97.5117 83.843 96.3175C86.2221 93.7581 88.6101 90.0231 90.8032 87.3158C97.7758 91.4475 104.827 96.3425 112.151 99.8647Z"
                fill={primaryStroke}
            />
            <path
                d="M231.066 67.4787C241.03 61.8417 251.735 57.6326 262.867 54.9744C257.822 43.5301 255.024 31.2205 254.624 18.7171C247.255 19.4078 239.851 19.6444 232.454 19.4257C224.426 19.1885 221.364 17.6246 221.836 26.7039C222.018 30.1872 229.488 68.3719 231.066 67.4787Z"
                fill={primaryStroke}
                fillOpacity="0.2"
            />
            <path
                d="M234.662 18.6572C229.096 18.5715 214.86 19.8346 208.437 20.4768C213.661 21.0763 235.804 19.5135 246.222 18.6572C244.688 18.6928 240.228 18.7428 234.662 18.6572Z"
                fill={primaryStroke}
            />
            <path
                d="M232.583 28.5048C227.017 28.4192 212.781 29.6823 206.358 30.3245C211.582 30.9239 233.725 29.3612 244.143 28.5048C242.609 28.5405 238.149 28.5905 232.583 28.5048Z"
                fill={primaryStroke}
            />
            <path
                d="M225.692 38.7841C221.621 38.3737 211.091 38.8012 206.335 39.0663C210.114 39.9689 226.46 39.7044 234.16 39.4593C233.034 39.4053 229.762 39.1946 225.692 38.7841Z"
                fill={primaryStroke}
            />
            <path
                d="M105.585 178.006C85.4044 177.875 33.7865 179.811 10.5002 180.795C29.4399 181.714 109.725 179.319 147.5 178.006C141.937 178.061 125.767 178.138 105.585 178.006Z"
                fill={primaryStroke}
            />
            <path
                d="M97.8914 192.006C77.8577 191.875 26.6166 193.811 3.50024 194.795C22.3016 195.714 102.001 193.319 139.5 192.006C133.978 192.061 117.925 192.138 97.8914 192.006Z"
                fill={primaryStroke}
            />
            <path
                d="M73.1423 206.859C58.3991 206.275 20.2633 206.883 3.03824 207.26C16.7251 208.544 75.9251 208.168 103.814 207.819C99.7333 207.743 87.8856 207.443 73.1423 206.859Z"
                fill={primaryStroke}
            />
        </svg>
    );
};
